import React, { useEffect } from "react";
import {
  SkillsContainer,
  SkillsTitle,
  SkillsAptitudCard,
  SkillsAptitudItem,
  SkillsAptitudImageTec,
  SkillsAptitudNameTec,
  SkillsAptitudCardTitle,
  SkillsAptitudesTec,
} from "./Skills.elements";
import java from "../../images/java.png";
import python from "../../images/python.png";
import javascript from "../../images/javascript.png";
import vb from "../../images/visual-basic.png";
import csharp from "../../images/c-sharp.png";
import spring from "../../images/spring.png";
import html from "../../images/html.png";
import css from "../../images/css.png";
import react from "../../images/react.png";
import prestshop from "../../images/prestashop.png";
import node from "../../images/node.png";
import mongodb from "../../images/mongoDB.png";
import mysql from "../../images/mysql.png";
import flask from "../../images/flask.png";
import Aos from "aos";
import "aos/dist/aos.css";

export default function Skills({ light, id }) {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <SkillsContainer id={id} light={light} className="seccion">
      <SkillsTitle light={light} data-aos="fade-up">
        HABILIDADES
      </SkillsTitle>
      <SkillsAptitudesTec data-aos="zoom-in-up" data-aos-easing="ease-in-sine">
        <SkillsAptitudCard light={light}>
          <SkillsAptitudCardTitle light={light}>
            Lenguajes de programación
          </SkillsAptitudCardTitle>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>Python</SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={python} />
          </SkillsAptitudItem>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>Java</SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={java} />
          </SkillsAptitudItem>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>
              JavaScript
            </SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={javascript} />
          </SkillsAptitudItem>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>
              Visual Basic .NET
            </SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={vb} />
          </SkillsAptitudItem>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>C#</SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={csharp} />
          </SkillsAptitudItem>
        </SkillsAptitudCard>
        <SkillsAptitudCard light={light}>
          <SkillsAptitudCardTitle light={light}>
            Desarrollo web
          </SkillsAptitudCardTitle>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>React</SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={react} />
          </SkillsAptitudItem>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>
              Prestashop
            </SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={prestshop} />
          </SkillsAptitudItem>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>Spring</SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={spring} />
          </SkillsAptitudItem>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>Html</SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={html} />
          </SkillsAptitudItem>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>Css</SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={css} />
          </SkillsAptitudItem>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>Node JS</SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={node} />
          </SkillsAptitudItem>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>
              Flask
            </SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={flask} />
          </SkillsAptitudItem>
        </SkillsAptitudCard>
        <SkillsAptitudCard light={light}>
          <SkillsAptitudCardTitle light={light}>
            Bases de datos
          </SkillsAptitudCardTitle>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>Mongo DB</SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={mongodb} />
          </SkillsAptitudItem>
          <SkillsAptitudItem>
            <SkillsAptitudNameTec light={light}>MySQL</SkillsAptitudNameTec>
            <SkillsAptitudImageTec src={mysql} />
          </SkillsAptitudItem>
        </SkillsAptitudCard>
      </SkillsAptitudesTec>
    </SkillsContainer>
  );
}
